import axios from 'axios';

import WhoAreWeModel from './who-are-we.model.js';

class WhoAreWeService {
	getPageData(lang) {
		return axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/singletons/get/whoAreWe?lang=${lang}`)
			.then(({ data }) => new WhoAreWeModel(data));
	}
}

export default new WhoAreWeService();
